import { IMountainPlayerData } from '../../data/mountainPlayer'
import { IGameAnswer } from '../../data/question'

const buildDataValues = (
	players: Array<IMountainPlayerData>,
	anwsers: Array<IGameAnswer>,
	areAnswersHidden: boolean
): Array<number> => {
	// Initialize all the counters that we will use later
	const correctAnswers = anwsers.filter((answer) => answer.correct).length
	let studentsWithoutAnswer = 0
	let studentsWithCorrectAnswer = 0
	let studentsWithIncorrectAnswer = 0

	// Initialize auxiliary answers map
	const answersMap: Map<string, IGameAnswer> = new Map()

	// Initialize the map with all students answers to 0
	const studentsAnswersMap: Map<string, number> = new Map()

	// Fill the maps
	anwsers.forEach((answer) => {
		studentsAnswersMap.set(answer.uid, 0)
		answersMap.set(answer.uid, answer)
	})

	// Add the students answers to the map
	players.forEach((player) => {
		// if the player has not answered the question
		if (!player.answered || !player.answersUids[0]) {
			studentsWithoutAnswer++
		} else {
			// if the player has answered the question, check each answer
			player.answersUids.forEach((playerAnswer) => {
				const previousValue = studentsAnswersMap.get(playerAnswer) || 0
				studentsAnswersMap.set(playerAnswer, previousValue + 1)
				// if the player has answered the question correctly
				const playerAnswerObj = answersMap.get(playerAnswer)
				if (playerAnswerObj && playerAnswerObj.correct) {
					studentsWithCorrectAnswer++
				} else {
					studentsWithIncorrectAnswer++
				}
			})
		}
	})

	// at this point all the counters are initialized, we can start building the data

	if (areAnswersHidden) {
		// The resultant array has one number for Correct, one for Incorrect and one for None
		return [studentsWithCorrectAnswer, studentsWithIncorrectAnswer, studentsWithoutAnswer * correctAnswers]
	} else {
		// The resultant array has one number for each answer and one for non answered
		return [...Array.from(studentsAnswersMap.values()), studentsWithoutAnswer * correctAnswers]
	}
}

export default buildDataValues
